import { Slot } from "radix-ui";

import { Alert } from "@/shared/ui/common/alert";
import { tw } from "@/shared/utils";
import type { Toast } from "./toast-store";

interface ToastMessageProps {
  toast: Toast;
  onClose: () => void;
}
export const ToastMessage = ({ toast, onClose }: ToastMessageProps) => {
  return (
    <Slot.Root
      onClick={onClose}
      onKeyUp={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClose();
        }
      }}
      role="button"
      tabIndex={0}
      className={tw(
        "pointer-events-auto z-50 max-w-lg overflow-hidden shadow-lg",
        toast.state === "open" && "duration-300 animate-in slide-in-from-right",
        toast.state === "isClosing" && "duration-500 animate-out fade-out-0",
      )}
    >
      <Alert type={toast.type}>{toast.message}</Alert>
    </Slot.Root>
  );
};
